export default function Marquee({ items }) {
  const list = items || ["SANKALP", "PROGRESS", "TRUST", "LEADERSHIP", "ETHICS", "REFORM", "REPRESENTATION"];
  return (
    <div className="marquee bg-[hsl(var(--bg-muted))] border-y border-[hsl(var(--border-c))] py-6">
      <div className="marquee-track text-3xl sm:text-5xl font-display tracking-wider text-[hsl(var(--primary))]">
        {[...list, ...list, ...list].map((w, i) => (
          <span key={i} className="inline-flex items-center gap-12">
            <span>{w}</span>
            <span className="w-2 h-2 bg-[hsl(var(--accent))] rounded-full" />
          </span>
        ))}
      </div>
    </div>
  );
}
